module.exports = __webpack_public_path__ + "img/daxue.75958d40.png";